import { render, staticRenderFns } from "./MeasuresSwiperItem.vue?vue&type=template&id=182c0571&scoped=true&"
import script from "./MeasuresSwiperItem.vue?vue&type=script&lang=js&"
export * from "./MeasuresSwiperItem.vue?vue&type=script&lang=js&"
import style0 from "./MeasuresSwiperItem.vue?vue&type=style&index=0&id=182c0571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182c0571",
  null
  
)

export default component.exports